import { FormEvent } from 'react';
import { Nav } from 'react-bootstrap';
import { NavWrapper, NavItemWrapper } from '../styles';
import { ICenter } from '@nkr/models/index';
import * as moment from 'moment';
import { subSections } from '../../subsections';

interface IProps {
    activeKey: string,
    center: ICenter,
    registrationId: number,
    fullname: string,
    isSuperAdmin: boolean
    onTabSelect: (key: string) => void
}

const DonorIntakeTabs = (props: IProps) => {
    const handleSelect = (e: FormEvent<Nav>) => {
        props.onTabSelect(e['eventKey']);
    };

    if (props.center == null && !props.isSuperAdmin)
        return null;

    const centerId  = props.center != null ? props.center.id : 0;
    const now       = moment();
    const expirePhp = moment('2025-06-30 00:00:00', 'YYYY-MM-DD HH:mm:ss');
    const show      = !props.isSuperAdmin && now.isBefore(expirePhp);

    const hrefPrefix = props.isSuperAdmin ? '/admin/dash' : `/center/${centerId}/donors`;

    const tabList = [
        { eventKey: 'TO-DO', label: 'To-Do', href: hrefPrefix + '/donor-intake/to-do', show: true },
        { eventKey: 'ALL', label: 'Search by Registrant', href: hrefPrefix + '/donor-intake/search', show: true },
        { eventKey: 'SEARCH-INTENDED', label: 'Search by Intended Recipient', href: hrefPrefix + '/donor-intake/search-by-intended', show: !props.isSuperAdmin },
        { eventKey: 'PENDING-DONOR', label: 'Pending Donor', href: __OUTSIDEURL__ + '/centers/donor-intake/pending-donor?ctrID=' + centerId, show: show },
        { eventKey: 'PENDING-CONTACT', label: 'Pending Contact', href: __OUTSIDEURL__ + '/centers/donor-intake/index?ctrID=' + centerId, show: show },
        { eventKey: 'PENDING-FOLLOWUP', label: 'Pending Followup', href: __OUTSIDEURL__ + '/centers/donor-intake/left-msg-email?ctrID=' + centerId, show: show },
        { eventKey: 'RULED-OUT', label: 'Ruled Out', href: __OUTSIDEURL__ + '/centers/donor-intake/ruled-out?ctrID=' + centerId, show: show },
        { eventKey: 'COMPLETE', label: 'Complete', href: __OUTSIDEURL__ + '/centers/donor-intake/completed?ctrID=' + centerId, show: show },
        { eventKey: 'PWL', label: 'PWL', href: __OUTSIDEURL__ + '/centers/pwl/labs-complete?ctrID=' + centerId, show: show },
        { eventKey: 'SEARCH', label: 'Search', href: __OUTSIDEURL__ + '/centers/donor-intake/search?ctrID=' + centerId, show: show },
        { eventKey: 'PWL-DETAILS', label: 'PWL Details - ' + props.fullname, href: hrefPrefix + '/donor-intake/pwl/details/' + props.registrationId, show: props.registrationId > 0 && props.fullname != '' && props.activeKey == 'PWL-DETAILS' },
        { eventKey: subSections.EDIT_DIAGNOSTICS, label: 'Diagnostics for ' + props.fullname, href: hrefPrefix + '/donor-intake/diagnostics/' + props.registrationId, show: props.activeKey.toUpperCase() == subSections.EDIT_DIAGNOSTICS },
    ];

    const filteredTabList = tabList.filter(x => x.show);

    return (
        <NavWrapper bsStyle='tabs' activeKey={props.activeKey} tabHeight={'32px'} onSelect={handleSelect}>
            {filteredTabList.map((item, index) =>
                <NavItemWrapper key={'tab-' + index} eventKey={item.eventKey} href={item.href}>
                    {item.label}
                </NavItemWrapper>
            )}
        </NavWrapper>
    );
}

export default DonorIntakeTabs;